import React from "react";
import { addProperty, updateProperty } from "../../utils/api";
import Banner from "../ui/Banner";

function PropertyFormModal({
  show,
  onClose,
  mode = "create", // "create" or "update"
  form,
  setForm,
  editingId,
  refresh,
  setBanner,
}) {
  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (mode === "create") {
        await addProperty(form);
        setBanner({
          type: "success",
          message: "Property created successfully!",
        });
      } else {
        await updateProperty({ id: editingId, ...form });
        setBanner({
          type: "success",
          message: "Property updated successfully!",
        });
      }
      refresh();
      onClose();
    } catch (err) {
      console.error("Error saving property:", err);
      setBanner({
        type: "danger",
        message: "Operation failed. Please try again.",
      });
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {mode === "create" ? "Add New Property" : "Update Property"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            {/* ✅ Banner inside modal */}
            <Banner
              type={form.bannerType}
              message={form.bannerMessage}
              onClose={() => setBanner({ type: "", message: "" })}
            />

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.title || ""}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={form.description || ""}
                  onChange={(e) =>
                    setForm({ ...form, description: e.target.value })
                  }
                  required
                ></textarea>
              </div>

              <div className="mb-3">
                <label className="form-label">Price</label>
                <input
                  type="number"
                  className="form-control"
                  value={form.price || ""}
                  onChange={(e) => setForm({ ...form, price: e.target.value })}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Location</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.location || ""}
                  onChange={(e) =>
                    setForm({ ...form, location: e.target.value })
                  }
                  required
                />
              </div>

              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={!!form.featured}
                  onChange={(e) =>
                    setForm({ ...form, featured: e.target.checked })
                  }
                />
                <label className="form-check-label">Featured</label>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {mode === "create" ? "Create" : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PropertyFormModal;
